import { Component, Input, OnInit } from "@angular/core";
import { finalize, map } from "rxjs/operators";
import { ActivitiesService } from "../models/activities.service";

const PAGE_SIZE = 10;

const GROUPABLE_TYPES = [
  "group.resolved",
  "group.unresolved",
  "group.muted",
  "group.unmuted",
];

@Component({
  selector: "ab-project-activities",
  templateUrl: "./project-activities.component.html",
})
export class ProjectActivitiesComponent implements OnInit {
  @Input() public project: any;
  public activities: any;
  public hasMore: boolean;
  public loading: boolean;
  public page: number;

  constructor(private activitiesService: ActivitiesService) {}

  public loadMore() {
    this.loadPage(this.page + 1);
  }

  public ngOnInit() {
    this.loadPage(1);
  }

  public trackBy(index: number, _item: any) {
    return index;
  }

  private defineUser(activity: any) {
    if (activity.activity === "deploy.create") {
      activity.userName = activity.parameters[":local_username"];
    }

    activity.user = {
      gravatarId: activity.userGravatarId,
      nameOrEmail: activity.userName || "Somebody",
    };

    return activity;
  }

  private decorateDeployActivity(activity: any) {
    if (activity.activity !== "deploy.create") {
      return;
    }

    activity.environment = activity.parameters[":environment"];
    const resolvedGroupIds = activity.parameters[":resolved_group_ids"] || [];
    activity.subActivities = {
      "group.resolved": resolvedGroupIds.map((id: any) => ({
        ownerType: "Deploy",
        trackableId: id,
      })),
    };

    return activity;
  }

  private groupGroupActivity(activity: any, i: number, activities: any) {
    if (GROUPABLE_TYPES.indexOf(activity.activity) === -1) {
      return;
    }
    if (activity.grouped) {
      return;
    }

    if (!activity.subActivities) {
      activity.subActivities = {};
    }
    if (!activity.subActivities[activity.activity]) {
      activity.subActivities[activity.activity] = [activity];
    }

    let next;
    while (
      // tslint:disable-next-line:no-conditional-assignment
      (next = activities[(i += 1)]) &&
      next.activity === activity.activity
    ) {
      const date = new Date(activity.createdAt);
      const nextDate = new Date(next.createdAt);
      const offset = date.getTime() - nextDate.getTime();

      // Don't group activities when createdAt difference exceeds 2 minutes.
      if (offset > 120000) {
        break;
      }

      next.grouped = true;
      activity.subActivities[activity.activity].push(next);
    }
  }

  private fetchActivities(projectId: number, page: number) {
    return this.activitiesService
      .query({
        projectId,
        limit: PAGE_SIZE,
        owner_type__exclude: "Deploy",
        page,
      })
      .pipe(
        map((activities: any) => {
          // Manipulate activities to allow simpler & resused rendering code.
          for (let i = 0; i < activities.length; i++) {
            const activity = activities[i];

            this.defineUser(activity);
            this.decorateDeployActivity(activity);
            this.groupGroupActivity(activity, i, activities);
          }

          return {
            activities: activities.filter((a: any) => !a.grouped),
            length: activities.length,
          };
        }),
      );
  }

  private loadPage(page: number) {
    this.loading = true;
    return this.fetchActivities(this.project.id, page)
      .pipe(
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe((data: any) => {
        this.activities = (this.activities || []).concat(data.activities);
        this.page = page;
        this.hasMore = data.length === PAGE_SIZE;
      });
  }
}
